import { createFileRoute } from '@tanstack/react-router'

import { Error } from '~/components/error'
import { MainShell } from '~/components/main-shell'

export const Route = createFileRoute('/_main-layout')({
  component: MainShell,
  errorComponent: Error,
})
